import { motion } from "framer-motion";
import { NavigationArrow, MapPin } from "@phosphor-icons/react";

const ADDRESS = "F26-B, Gali No.2, Molarband Extension, Badarpur, New Delhi-110044";
const EMBED_SRC =
    "https://maps.google.com/maps?q=F26-B%20Gali%20No.2%20Molarband%20Extension%20Badarpur%20New%20Delhi%20110044&t=&z=15&ie=UTF8&iwloc=&output=embed";
const DIRECTIONS_URL =
    "https://www.google.com/maps/dir/?api=1&destination=F26-B+Gali+No.2+Molarband+Extension+Badarpur+New+Delhi+110044";

export default function MapSection() {
    return (
        <section className="border-t border-white/10 px-5 py-24 md:px-10 md:py-32" data-testid="map-section">
            <div className="grid gap-12 lg:grid-cols-12">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    className="flex flex-col justify-between lg:col-span-4"
                >
                    <div>
                        <p className="mb-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-blaze md:text-xs">
                            <span className="inline-block h-2 w-2 bg-blaze" />
                            Find Us
                        </p>
                        <h2 className="font-display text-4xl uppercase leading-[0.95] tracking-tight md:text-5xl">
                            On the map. <span className="text-outline-faint">On the move.</span>
                        </h2>
                    </div>
                    <div className="mt-10 lg:mt-0">
                        <div className="flex items-start gap-4">
                            <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-white/15 text-blaze">
                                <MapPin size={20} weight="duotone" />
                            </span>
                            <p className="text-base leading-relaxed text-white/70" data-testid="map-address">{ADDRESS}</p>
                        </div>
                        <a
                            href={DIRECTIONS_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="map-directions-button"
                            className="group mt-8 inline-flex items-center gap-3 border border-white/25 px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-200 hover:border-blaze hover:text-blaze"
                        >
                            <NavigationArrow size={15} weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            Get Directions
                        </a>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
                    className="lg:col-span-8"
                >
                    <div className="border border-white/15 p-1.5" data-testid="map-frame">
                        <iframe
                            src={EMBED_SRC}
                            title="Akash Group office — Badarpur, New Delhi"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            className="h-[380px] w-full md:h-[460px]"
                            style={{ filter: "grayscale(0.35) sepia(0.12) contrast(0.95)" }}
                            data-testid="map-iframe"
                        />
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
